<template>
    <div class="vehicle-details text-center">
        <div class="vehicle-image">
            <trim-image :trim="trim" />
        </div>
        <h1>{{ trim.year }} {{ trim.make }} {{ trim.model }}</h1>
        <h2>{{ trim.trim }} {{ trim.name }}</h2>
        <div class="details">
            <p v-if="baseTrim">
                Includes select features of {{ baseTrimName }} model plus...
            </p>
            <p v-else>
                Includes the following standard features...
            </p>
            <ul>
                <li v-for="(standard, key) in standardDiff" :key="key">
                    {{ standard.value }}
                </li>
            </ul>
            <div>
                <b-link @click="viewAll">
                    View All
                </b-link>
            </div>
        </div>
        <action-buttons :trim="trim" />
    </div>
</template>

<style lang="scss" scoped>
h1 {
    font-family: $helvetica-55-Roman;
    font-size: 18px;
    font-weight: normal;
}

h2 {
    font-size: 14px;
    font-weight: normal;
}

.details {
    p {
        font-size: 14px;
        font-family: $helvetica-55-Roman;
    }

    ul {
        margin: 0 40px;
        max-height: 200px;
        overflow-x: auto;

        li {
            text-align: left;
            font-size: 12px;
            font-family: $helvetica-46-light-italic;
            font-style: italic;
        }
    }
}
</style>

<script>
import _ from "lodash";
import TrimDetailsMixin from "../mixins/TrimDetailsMixin";
import TrimImage from "./TrimImage";
import ActionButtons from "./ActionButtons";
import FeaturedOptionsMixin from "../mixins/FeaturedOptionsMixin";

export default {
    components: { ActionButtons, TrimImage },
    mixins: [TrimDetailsMixin, FeaturedOptionsMixin],

    props: {
        trim: {
            type: Object,
            required: true
        },
        baseTrim: {
            type: Object,
            required: false,
            default: null
        }
    },

    computed: {
        baseTrimName() {
            const baseTrimName = _.get(this.baseTrim, "trim");

            if (_.isNil(baseTrimName)) {
                return "base";
            }

            return baseTrimName;
        }
    },

    methods: {
        viewAll() {
            this.$emit("view-all-options");
        }
    }
};
</script>
